import * as React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// COMPONENTS
import { Button } from "@lululemon/ecom-pattern-library-button";
import { linealTagIcon } from "@lululemon/ecom-pattern-library-icons";

// CONSTANTS
import { SHOP_THIS_LOOK } from "../utils/constants";

// STYLES
import styles from "../styles/model-is-wearing-button.module.scss";

export const ModelIsWearingButton = ({
  onClick,
  renderShopThisLookButton,
  shouldRenderTagIcon,
  className
}) => (
  <Button
    data-testid="model-is-wearing-button"
    className={classNames(styles.modelIsWearingBtn, "animated animated-fast", {
      [styles.visible]: renderShopThisLookButton,
      fadeInUp: renderShopThisLookButton,
      fadeOutDown: !renderShopThisLookButton,
      [className]: !!className
    })}
    icon={shouldRenderTagIcon && linealTagIcon}
    onClick={onClick}
    data-lulu-track="pdp-miw:shop-this-look"
  >
    {SHOP_THIS_LOOK}
  </Button>
);

ModelIsWearingButton.defaultProps = {
  onClick: undefined,
  renderShopThisLookButton: false,
  shouldRenderTagIcon: true,
  className: undefined
};

ModelIsWearingButton.propTypes = {
  onClick: PropTypes.func,
  renderShopThisLookButton: PropTypes.bool,
  shouldRenderTagIcon: PropTypes.bool,
  className: PropTypes.string
};

export default ModelIsWearingButton;
